import { Card } from "../ui/card";
import waterImg from "../../images/waterglas.png";
const MissionQuality = () => {
  return (
    <div>
      <div className="container mx-auto mt-20 mb-20 md:px-40 sm:px-40">
        <h1 className="font-bold text-start text-primary">L’hygiène</h1>
        <p className="mt-2 text-start">
          L’eau destinée à la consommation répond à des normes de qualité très
          strictes définies par le code de la santé publique. Elle est contrôlée
          en amont de l’usine (l’eau brute) et à sa sortie de l’usine (eau
          potable). <br />
          En amont :  l’agence régionale de santé (ARS) contrôle la qualité de
          l’eau brute sur une dizaine de prélèvements au niveau des{" "}
          <span className="underline">forages</span> . La 
          <span className="undeline">SEOP</span>, délégataire, effectue elle
          aussi des contrôles.
          <br />
          L’eau prélevée dans la nappe phréatique de Croissy-sur-Seine est ainsi
          soumise à de nombreuses analyses. <br />
          En sortie d’usine : pour être potable, l’eau doit répondre à de
          nombreux critères biologiques, physico-chimiques et organoleptiques
          (odeur, saveur). L’ARS effectue des contrôles sanitaires avec plus de
          10 000 analyses par an sur le territoire, qui portent sur l’ensemble
          du système d’alimentation en eau (usine, réservoirs et réseaux de
          distribution). Les échantillons d’eau prélevés sont analysés par des
          laboratoires agréés par le ministère de la Santé. <br />
          La SEOP assure, quant à elle, une surveillance permanente grâce à plus
          de 100 capteurs, l’analyse de prélèvements dans les laboratoires de
          l’usine et l’envoi d’échantillons ponctuels à un laboratoire
          accrédité.
        </p>
        <div className="relative mt-20 mb-10">
          <div className="absolute top-[-50px] right-6">
            <Card className="p-5 w-52 bg-[#3CC6F7] border-primary">
              <h1 className="font-semibold text-white">
                Pour tout savoir sur la qualité de l’eau dans votre commune,
                vous pouvez consulter le site du{" "}
                <span className="underline"> ministère de la Santé.</span>
              </h1>
            </Card>
          </div>
          <img src={waterImg} alt="" className="w-full rounded-lg" />
        </div>
        <h1 className="font-bold text-start text-primary">Le confort</h1>
        <p className="text-start">
          Si elle est consommable, l’eau n’en est pas pour autant transparente
          ou <span className="underline">AQUAVESC</span>  s’attache à la rendre
          agréable à déguster. Grâce à un nouveau procédé de 
          <span className="underline">décarbonatation collective</span> par
          décantation, l’eau est adoucie.{" "}
          <span className="underline">L’usine de Louveciennes </span> produit
          une eau allégée de 50 % du calcaire qu’elle contient. L’avantage est
          double : la durée de vie des appareils domestiques est prolongée et
          les consommations énergétiques baissent considérablement. Depuis la
          mise en place de ce procédé, on estime à près de 200 euros les
          économies annuelles réalisées pour un foyer de quatre personnes.
        </p>
      </div>
    </div>
  );
};

export default MissionQuality;
